/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './herbal-business-sign-up';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({ wrapper, label, errorMessage, input, isAddressInput }) => {
    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && label}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;

    const {
        FormWrapper,
        buttons,
        items,
        errorMessage,
        indicatedText,
        disclaimer,
        formDescription,
        accountExistMessage
    } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                <Node {...FormWrapper}>
                    {formDescription}
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <BusinessSignUpItem key={item.id} {...item} />;
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {accountExistMessage &&
                        accountExistMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                    {indicatedText}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
